import { ChannelPinMessageResponse } from "../proto/ChannelPinMessage_pb";
import { GroupPinMessageResponse } from "../proto/GroupPinMessage_pb";
import store from "../store";
import { editRoom } from "../store/rooms/actions";
import BaseHandler from "./BaseHandler";

export default class HandleRoomPinMessageResponse extends BaseHandler<GroupPinMessageResponse | ChannelPinMessageResponse> {
  handle() {
    const roomPinMessageResponse = this.response.toObject();
    store.dispatch(
      editRoom({
        roomId: roomPinMessageResponse.roomId,
        room: {
          pinnedMessage: roomPinMessageResponse?.pinnedMessage,
        },
      })
    );
  }
}
